import { Dictionary } from '@/types';

export const DATE_FORMAT_MASK = 'YYYY-MM-DD';
export const ACTIVITY_ROUTE = 'activity';
export const ACTIVITIES_ROUTE = 'activities';
export const ACTIVITIES_MAP_ROUTE = 'activities-map';
export const CALENDAR_ROUTE = 'activities-calendar';
export const FILTER_NAV = [];
/*
export const FILTER_NAV = [
  {
    text: 'Каталог',
    variant: 'catalog',
    to: {
      name: ACTIVITIES_ROUTE,
    },
  },
  {
    text: 'Карта',
    variant: 'map',
    to: {
      name: ACTIVITIES_MAP_ROUTE,
    },
  },
];
*/
export const FILTER_TITLE = 'Гибкий поиск мероприятий';
export const MONTHS: Dictionary<string> = {
  '1': 'Январь',
  '2': 'Февраль',
  '3': 'Март',
  '4': 'Апрель',
  '5': 'Май',
  '6': 'Июнь',
  '7': 'Июль',
  '8': 'Август',
  '9': 'Сентябрь',
  '10': 'Октябрь',
  '11': 'Ноябрь',
  '12': 'Декабрь',
};
export const MONTHS2: Dictionary<string> = {
  '1': 'Января',
  '2': 'Февраля',
  '3': 'Марта',
  '4': 'Апреля',
  '5': 'Мая',
  '6': 'Июня',
  '7': 'Июля',
  '8': 'Августа',
  '9': 'Сентября',
  '10': 'Октября',
  '11': 'Ноября',
  '12': 'Декабря',
};
export const NAME = 'Календарь мероприятий';


// WEBPACK FOOTER //
// ./src/pages/activities/const.ts